/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum GrantType {
  ViewUsers = 'viewUsers',
  ManageUsers = 'manageUsers',
  ViewRoles = 'viewRoles',
  ManageRoles = 'manageRoles',
  ViewGroups = 'viewGroups',
  ManageGroups = 'manageGroups',
  ViewTeamPlanners = 'viewTeamPlanners',
  ManageTeamPlanners = 'manageTeamPlanners',
  ViewLaborActivities = 'viewLaborActivities',
  ManageLaborActivities = 'manageLaborActivities',
  ViewCostTypes = 'viewCostTypes',
  ManageCostTypes = 'manageCostTypes',
  ViewLaborCosts = 'viewLaborCosts',
  ManageLaborCosts = 'manageLaborCosts',
  ViewWorkWorkPackageStatuses = 'viewWorkWorkPackageStatuses',
  ManageWorkPackageStatuses = 'manageWorkPackageStatuses',
  ManageWorkPackageTypes = 'manageWorkPackageTypes',
  ViewWorkPackageTypes = 'viewWorkPackageTypes',
  ManageWorkPackagePriorities = 'manageWorkPackagePriorities',
  ViewWorkPackagePriorities = 'viewWorkPackagePriorities',
  ViewWorkProfiles = 'viewWorkProfiles',
  ViewWorkCalendarDays = 'viewWorkCalendarDays',
  ViewProject = 'viewProject',
  CreateProject = 'createProject',
  EditProject = 'editProject',
  DeleteProject = 'deleteProject',
  EditProjectInfo = 'editProjectInfo',
  EditProjectDates = 'editProjectDates',
  EditProjectStatus = 'editProjectStatus',
  EditProjectArchived = 'editProjectArchived',
  EditProjectPublic = 'editProjectPublic',
  EditProjectWorkPackageCategories = 'editProjectWorkPackageCategories',
  ExportProjectWorkPackages = 'exportProjectWorkPackages',
  ViewWorkPackages = 'viewWorkPackages',
  CreateWorkPackages = 'createWorkPackages',
  CreateWorkPackagesFromTemplate = 'createWorkPackagesFromTemplate',
  EditWorkPackages = 'editWorkPackages',
  DeleteWorkPackages = 'deleteWorkPackages',
  EditWorkPackagesInfo = 'editWorkPackagesInfo',
  EditWorkPackagesDates = 'editWorkPackagesDates',
  EditWorkPackagesStatus = 'editWorkPackagesStatus',
  EditWorkPackagesType = 'editWorkPackagesType',
  EditWorkPackagesPriority = 'editWorkPackagesPriority',
  EditWorkPackagesAssignee = 'editWorkPackagesAssignee',
  EditWorkPackagesTargetGroup = 'editWorkPackagesTargetGroup',
  EditWorkPackagesHierarchy = 'editWorkPackagesHierarchy',
  EditWorkPackagesDynamicFormsSchema = 'editWorkPackagesDynamicFormsSchema',
  EditWorkPackagesDynamicFormsValue = 'editWorkPackagesDynamicFormsValue',
  EditWorkPackagesCategories = 'editWorkPackagesCategories',
  EditWorkPackagesAttachments = 'editWorkPackagesAttachments',
  EditWorkPackagesInventoryTransactions = 'editWorkPackagesInventoryTransactions',
  EditAssignedWorkPackagesInfo = 'editAssignedWorkPackagesInfo',
  EditAssignedWorkPackagesDates = 'editAssignedWorkPackagesDates',
  EditAssignedWorkPackagesStatus = 'editAssignedWorkPackagesStatus',
  EditAssignedWorkPackagesType = 'editAssignedWorkPackagesType',
  EditAssignedWorkPackagesPriority = 'editAssignedWorkPackagesPriority',
  EditAssignedWorkPackagesAssignee = 'editAssignedWorkPackagesAssignee',
  EditAssignedWorkPackagesTargetGroup = 'editAssignedWorkPackagesTargetGroup',
  EditAssignedWorkPackagesHierarchy = 'editAssignedWorkPackagesHierarchy',
  EditAssignedWorkPackagesDynamicFormsSchema = 'editAssignedWorkPackagesDynamicFormsSchema',
  EditAssignedWorkPackagesDynamicFormsValue = 'editAssignedWorkPackagesDynamicFormsValue',
  EditAssignedWorkPackagesCategories = 'editAssignedWorkPackagesCategories',
  EditAssignedWorkPackagesAttachments = 'editAssignedWorkPackagesAttachments',
  EditAssignedWorkPackagesInventoryTransactions = 'editAssignedWorkPackagesInventoryTransactions',
  ViewBudgets = 'viewBudgets',
  UpdateBudgets = 'updateBudgets',
  CreateBudget = 'createBudget',
  ManageEstimates = 'manageEstimates',
  ManageEffective = 'manageEffective',
  ManageSelfLaborCost = 'manageSelfLaborCost',
  ViewCashAnalytics = 'viewCashAnalytics',
  ViewCostAnalytics = 'viewCostAnalytics',
  ViewProjectCollaborators = 'viewProjectCollaborators',
  ManageProjectUsersMemberships = 'manageProjectUsersMemberships',
  ManageProjectGroupsMemberships = 'manageProjectGroupsMemberships',
  ViewGlobalConfigurations = 'viewGlobalConfigurations',
  ManageGlobalConfigurations = 'manageGlobalConfigurations',
  ManageCustomFieldsSchema = 'manageCustomFieldsSchema',
  ManageWorkPackageFieldsSchema = 'manageWorkPackageFieldsSchema',
  ManageTemplates = 'manageTemplates',
  ViewTemplates = 'viewTemplates',
  ViewInventoryItems = 'viewInventoryItems',
  ManageInventoryItems = 'manageInventoryItems',
  ViewInventoryTransactions = 'viewInventoryTransactions',
  ManageInventoryTransactions = 'manageInventoryTransactions',
  ManageFileSystem = 'manageFileSystem',
  ViewFileSystem = 'viewFileSystem'
}
